"use client";  // This line marks this component as a Client Component

import React, { useState } from 'react';
import { useMediaQuery } from "react-responsive";
import apiRoutes from '../../config/apiRoutes';  // Adjust the path as necessary
import { useTranslation } from 'react-i18next'; 
import ContactDesktop from './Desktop/ContactDesktop';
import ContactMobile from './Mobile/ContactMobile';
import Loader from '../Loader/Loader';

const Contact = () => {
  const { t } = useTranslation('translation');
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = { name, email, message };

    setIsLoading(true); 
    
    try {
      const response = await fetch(apiRoutes.submitForm, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      showAlert(t('contactSuccess'), 'success');
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      showAlert(t('contactError'), 'error');
    } finally {
      setIsLoading(false); 
    }
  };

  const showAlert = (message, type) => {
    setAlert({ show: true, message, type });
    setTimeout(() => {
      setAlert({ show: false, message: '', type: '' });
    }, 3000);  // Alert disappears after 3000 milliseconds
  };

  const translations = {
    contactTitle: t('contactTitle'),
    contactSubtitle: t('contactSubtitle'),
    contactName: t('contactName'),
    contactEmail: t('contactEmail'),
    contactMessage: t('contactMessage'),
    contactMessagePlace: t('contactMessagePlace'),
    contactSubmit: t('contactSubmit')
  };

  return (
    <section id="contact" className="overflow-hidden py-16 md:py-20 lg:py-28">
      {/* Afficher le loader si isLoading est true */}
      {isLoading && <Loader />}
      
      {isMobile ? (
        <ContactMobile
          name={name}
          email={email}
          message={message}
          alert={alert}
          translations={translations}
          onNameChange={(e) => setName(e.target.value)}
          onEmailChange={(e) => setEmail(e.target.value)}
          onMessageChange={(e) => setMessage(e.target.value)}
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />
      ) : (
        <ContactDesktop
          name={name}
          email={email}
          message={message}
          alert={alert}
          translations={translations}
          onNameChange={(e) => setName(e.target.value)}
          onEmailChange={(e) => setEmail(e.target.value)}
          onMessageChange={(e) => setMessage(e.target.value)}
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />
      )}
    </section>
  );
};

export default Contact;